"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporaryConnectionRpcRemote = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const logger = new utils_1.Logger(module);
class TemporaryConnectionRpcRemote extends dht_1.RpcRemote {
    async openConnection() {
        try {
            const response = await this.getClient().openConnection({}, this.formDhtRpcOptions());
            return response.accepted;
        }
        catch (err) {
            logger.debug(`temporaryConnection to ${(0, dht_1.toNodeId)(this.getPeerDescriptor())} failed`, { err });
            return false;
        }
    }
    async closeConnection() {
        try {
            await this.getClient().closeConnection({}, this.formDhtRpcOptions({
                connect: false,
                notification: true
            }));
        }
        catch (err) {
            logger.trace(`closeConnection to ${(0, dht_1.toNodeId)(this.getPeerDescriptor())} failed`, { err });
        }
    }
}
exports.TemporaryConnectionRpcRemote = TemporaryConnectionRpcRemote;
//# sourceMappingURL=TemporaryConnectionRpcRemote.js.map